import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { MultiSelect, MultiSelectProps } from "../../core/components/multiSelect";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"

export default class EditProductGroups extends React.Component<EditProductGroupsProps, EditProductGroupsState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _factory = ComponentHelper.createFactory();
    private _fullLoaded: boolean;
    private _userLanguage: number;
    private _nextId: number;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (!Helper.isNullOrEmpty(this.state.currentTranslation.Name)) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }

                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = { gridData: [], deleteButtonEnabled: false, dialogOpen: false, currentItem: null, currentTranslation: null };
    }
    private _getGridData = () => {
        let url = "PartsSettings/GetProductGroups";
        HTTPService.get<JsonResultClass<ProductGroup[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this._userLanguage = result.AdditionalData["UserLanguage"];
                    this._nextId = result.AdditionalData["NextId"];
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let item: ProductGroup = this.state.currentItem;
        if (item.IsNew) {
            item.Translations.push(this.state.currentTranslation);
        } else {
            for (let i = 0; i < item.Translations.length; i++) {
                if (item.Translations[i].Language === this._userLanguage) {
                    item.Translations[i] = this.state.currentTranslation;
                }
            }            
        }
        let url = "PartsSettings/SaveProductGroup";
        HTTPService.post<JsonResultClass>(url, { model: item }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createTextBox("Key")}
                            {this._createTextBox("Name")}
                            {this._createTextBox("Discription")}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createTextBox = (type: "Key"|"Name"|"Discription") => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        let linkProps: TranslationsLinkProps;
        let label = "";

        switch (type) {
            case "Key":
                label = this._translations["Standard.Key"];
                props.value = this.state.currentItem.Id;
                props.disabled = true;
                break;
            case "Name":
                label = this._translations["Standard.Name"] + "*";
                props.field.maxLength = 33;
                props.value = Helper.getValueOrDefault(this.state.currentTranslation.Name, "");
                props.onChange = (field: { model: string }, value: any) => {
                    let item = this.state.currentTranslation;
                    item.Name = value;
                    this.setState({ currentTranslation: item });
                }

                linkProps = {
                    languageId: this._userLanguage,
                    multiline: false,
                    onOkClick: this._handleTranslationsChange,
                    translations: this.state.currentItem.Translations.filter(f => f.Language !== this._userLanguage),
                    visible: !this.state.currentItem.IsNew
                };
                break;
            case "Discription":
                label = this._translations["Standard.Beschreibung"];
                props.value = Helper.getValueOrDefault(this.state.currentTranslation.Discription, "");
                props.field.multiLine = true;
                props.onChange = (field: { model: string }, value: any) => {
                    let item = this.state.currentTranslation;
                    item.Discription = value;
                    this.setState({ currentTranslation: item });
                }

                linkProps = {
                    languageId: this._userLanguage,
                    multiline: true,
                    onOkClick: this._handleTranslationsChange,
                    translations: this.state.currentItem.Translations.filter(f => f.Language !== this._userLanguage),
                    visible: !this.state.currentItem.IsNew
                };
                break;
        }
        const link = (type !== "Key") ? (<TranslationsLink {...linkProps} />): (<></>);
        return (
            <FieldInstance label={label} noHover={true}>
                <TextBox {...props} />
                {link}
            </FieldInstance>
        );
    }

    private _handleTranslationsChange = (translations: ProductGroupTranslation[]) => {
        let lst = this.state.currentItem.Translations;
        translations.push(this.state.currentTranslation);
        for (let i = 0; i < lst.length; i++) {
            for (let j = 0; j < translations.length; j++) {
                if (lst[i].Language === translations[j].Language) {
                    lst[i].Language = translations[j].Language;
                }
            }
        }
        let item = this.state.currentItem;
        item.Translations = lst;
        this.setState({ currentItem: item });
    }
   
    private _delete = (dataItem: ProductGroup) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "PartsSettings/DeleteProductGroup";
                HTTPService.post<JsonResultClass>(url, { model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: ProductGroup = null) => {
        let item: ProductGroupTranslation;
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                GridText: "",
                Id: this._nextId,
                IsDeletable: true,
                IsNew: true,
                Translations: []
            };
            item = {
                Discription: "",
                Language: this._userLanguage,
                Name: ""
            };
        } else {
            for (let i = 0; i < dataItem.Translations.length; i++) {
                if (dataItem.Translations[i].Language == this._userLanguage) {
                    item = dataItem.Translations[i];
                    break;
                }
            }
        }
        this.setState({ dialogOpen: true, currentItem: dataItem, currentTranslation: item })
    }

    private _createGrid = () => {

        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="generalSettings_ProductGroupsGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: ProductGroup) => {
        if (Helper.hasValue(dataItem))
            this.setState({ deleteButtonEnabled: dataItem.IsDeletable });
        else
            this.setState({ deleteButtonEnabled: false });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: ProductGroup) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.productGroupGridOptions;
        this._getGridData();
    }

    render() {
        this._fullLoaded = Helper.hasValue(this._translations) && Helper.hasValue(this._options);
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

class TranslationsLink extends React.Component<TranslationsLinkProps, TranslationsLinkState> {
    private _factory = ComponentHelper.createFactory();
    private _localStorageKey = "ProductGroups_Languages";
    private _translations: {} = null;
    private _currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private _currentLanguage: number;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOkClick(this.state.values);
                },
                primary: true
            }
        ],
        afterClose: () => {
            Helper.saveDataToStorage(this._localStorageKey, this._currentLanguageSelection, false);
            this.setState({ dialogOpen: false });
        },
        width: 500

    };

    constructor(props: TranslationsLinkProps) {
        super(props);
        this._localStorageKey += "_" + props.languageId
        this._currentLanguage = null;
        let languages = Helper.loadDataFromStorage(this._localStorageKey);
        if (Helper.hasValue(languages)) {
            this._currentLanguageSelection = languages;
        }
        this.state = { dialogOpen: false, values: props.translations };
    }

    private _loadTranslations = () => {
        Helper.getTranslations(["Standard.TranslationLink", "Sprachen.Sprache", "Standard.Beschreibung"])
            .then((result) => {
                this._translations = result.Data;
                this.setState({});
            });
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createDialogBody()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createDialogBody = () => {
        if (this.props.multiline) {
            return (
                <>
                    {this._createDropDownList()}
                    {Helper.hasValue(this._currentLanguage) ? this._createMultilineTextBox(): <></>}
                </>
            );
        } else {
            return (
                <>
                    { this._createMultiSelect()}
                    { this._createTextBoxes()}
                </>
            );
        }
    }

    private _createMultiSelect = () => {
        let props: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        props.value = this._currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (field: { model: string }, value) => {
            this._currentLanguageSelection = value;
            this.setState({});
        };
        props.onDataLoaded = (field: { model: string }, value: any) => { };
        return (
            <FieldInstance label={this._translations["Sprachen.Sprache"]} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private _createTextBoxes = () => {
        let elemets = [];
        for (let i = 0; i < this._currentLanguageSelection.length; i++) {
            const t = this._currentLanguageSelection[i];
            elemets.push(
                <div key={kendo.guid()} style={{ flexShrink: 0 }}>
                    <FieldInstance label={t.Sprache} noHover={true} >
                        <TextBox {...this._createTextBoxProps(t)} />
                    </FieldInstance>
                </div>
            );
        }
        return elemets;
    }

    private _createTextBoxProps = (language: { Language: number, Sprache: string }) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.name = language.Language.toString();
        props.onChange = this.handleTextBoxesChances;
        props.value = Helper.getValueOrDefault(this.state.values.find(f => f.Language == language.Language).Name, "");
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id: number = 0;
        for (let i = 0; i < this.state.values.length; i++) {
            if (this.state.values[i].Language.toString() == field.name) {
                id = i;
                break;
            }
        }
        let items = this.state.values;
        items[id].Name = value;
        this.setState({ values: items });
    }

    private _createDropDownList = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.value = this._currentLanguage;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (field: { model: string }, value) => {
            this._currentLanguage = value;
            this.setState({});
        };
        props.onDataLoaded = (field: { model: string }, value: any) => { };
        return (
            <FieldInstance label={this._translations["Sprachen.Sprache"]} noHover={true} >
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private _createMultilineTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.values.filter(f => f.Language === this._currentLanguage)[0].Discription, "");
        props.field.multiLine = true;
        props.onChange = (field: { model: string }, value: any) => {
            let lst = this.state.values;
            for (let i = 0; i < lst.length; i++) {
                if (lst[i].Language == this._currentLanguage) {
                    lst[i].Discription = value;
                    break;
                }
            }
            this.setState({ values: lst });
        }
        return (
            <FieldInstance label={this._translations["Standard.Beschreibung"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }

        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }

        if (this.props.visible) {
            return (
                <>
                    <div style={divStyle}>
                        <label style={labelStyle} onClick={this._openDialog}>{this._translations["Standard.TranslationLink"]}</label>
                    </div>

                </>
            );
        } else {
            return (<></>);
        }        
    }

    componentDidMount() {
        this._loadTranslations();
    }

    render() {
        const link = Helper.hasValue(this._translations) ? this._createLink() : <></>;
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {link}
                {dialog}
            </>
        );
    }

}

interface TranslationsLinkProps {
    multiline: boolean;
    translations: ProductGroupTranslation[];
    languageId: number;
    onOkClick: (translations: ProductGroupTranslation[]) => void;
    visible: boolean;
}

interface TranslationsLinkState {
    values: ProductGroupTranslation[];
    dialogOpen: boolean;
}

interface EditProductGroupsProps {
    entity: any;
    context: ContextGeneralSettingsApp;
}

interface EditProductGroupsState {
    gridData: ProductGroup[];
    deleteButtonEnabled: boolean;
    dialogOpen: boolean;
    currentItem: ProductGroup;
    currentTranslation: ProductGroupTranslation;
}

interface ProductGroup {
    Id: number;
    GridText: string;
    Translations: ProductGroupTranslation[];
    IsNew: boolean;
    IsDeletable: boolean;
}

interface ProductGroupTranslation {
    Language: number;
    Name: string;
    Discription: string;
}